import React from "react";
import { SiteListingTableProps } from "../../../type";
import TableExtend from "shared/components/Table";

const SiteListingTable = ({
  sites,
  tableMapping,
  onFiltered,
  onRowClick,
}: SiteListingTableProps) => {
  console.log(sites, tableMapping);
  return (
    <TableExtend
      responsive
      striped
      tableData={sites}
      tableMapping={tableMapping}
      onFilter={onFiltered}
      onRowClick={onRowClick}
    />
  );
};

export default SiteListingTable;
